import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBanknote1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"banknote-1,money, bill"} maskId="square-filled-radius-0-stroke-1-IconBanknote1"><path fillRule="evenodd" clipRule="evenodd" d="M1 4H23V20H1V4ZM3 6V7H5V6H3ZM19 17H21V18H19V17ZM12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBanknote1;
